import React from 'react';

import useMultiLanguageTranslation from 'hooks/useMultiLanguageTranslation';

import { TOrbit } from '../../../i18n/TModules';
import { WizardPrize } from '../wizardModel';
import { RadioGroup } from './controls';
import { LoyaltySelect, TextField } from './fields';
import { Line, Sub, Words } from './layout';
import { RewardPicker } from './pickers';

const TP = `${TOrbit}.wizard.prize`;

interface IPrizeFieldsProps<T extends WizardPrize> {
  name: string;
  prize: T;
  onChange: (prize: T) => void;
  /** The reward list a choose-your-prize game may offer: tagged rewards only. */
  rewardQuery?: Record<string, unknown>;
}

/** 6778:20286-:20303 / :20557-:20573: "Users will get: Points | A Reward" and its one line. */
const PrizeFields = <T extends WizardPrize>({
  name,
  prize,
  onChange,
  rewardQuery
}: IPrizeFieldsProps<T>) => {
  const { t } = useMultiLanguageTranslation();
  const set = (patch: Partial<WizardPrize>) => onChange({ ...prize, ...patch });
  return (
    <>
      <Line>
        <Words>{t(`${TP}.getLeadIn`)}</Words>
        <RadioGroup<WizardPrize['type']>
          name={name}
          label={t(`${TP}.getLeadIn`)}
          value={prize.type}
          options={[
            { value: 'points', label: t(`${TP}.points`) },
            { value: 'reward', label: t(`${TP}.reward`) }
          ]}
          onChange={type => set({ type })}
        />
      </Line>
      <Sub>
        {prize.type === 'points' ? (
          <Line>
            <Words $muted>{t(`${TP}.award`)}</Words>
            <TextField
              label={t(`${TP}.award`)}
              placeholder="0"
              inputMode="numeric"
              value={prize.points}
              onChange={points => set({ points })}
            />
            <Words $muted>{t(`${TP}.pointsFrom`)}</Words>
            <LoyaltySelect value={prize.loyalty} onChange={loyalty => set({ loyalty })} />
          </Line>
        ) : (
          <Line>
            <Words $muted>{t(`${TP}.issue`)}</Words>
            <RewardPicker
              label={t(`${TP}.selectReward`)}
              value={prize.reward}
              queryParams={rewardQuery}
              onChange={reward => set({ reward })}
            />
          </Line>
        )}
      </Sub>
    </>
  );
};

export default PrizeFields;
